import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { LobFilterComponent } from "./lob-filter.component";

import { MatButtonModule } from "@angular/material/button";
import { MatTreeModule } from "@angular/material/tree";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatIconModule } from "@angular/material/icon";

import { OrgFilterModule } from "../../containers/org-filter/org-filter.module";

// Ensure org store + effects exist wherever <app-lob-filter> is used
import { ConsultantSearchStateModule } from "../../../consultant-skill/state/consultant-search-state.module";

@NgModule({
  declarations: [LobFilterComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatTreeModule,
    MatCheckboxModule,
    MatIconModule,
    OrgFilterModule,
    ConsultantSearchStateModule,
  ],
  exports: [LobFilterComponent],
})
export class LobFilterModule {}
